import React, { useState, useEffect } from "react";
import { useReactiveVar } from "@apollo/client";
import { Hub } from "aws-amplify";
import { useNavigate, Navigate, Outlet } from "react-router-dom";
import {
  Box,
  Typography,
  AppBar,
  Button,
  Toolbar,
  Tabs,
  Link,
  Tab,
  Stack,
  Container,
} from "@mui/material";
import SvgIcon from "@mui/material/SvgIcon";
import icon from "../assets/Henrick-logo.png";

import Footer from "../component/Footer";
import getTopNav from "../function/getTopNav";
import { userVar, userEntityRelationVar } from "../client/cache";
import ContactUsForConsultation from "../component/ContactUsForConsultation";

function Copyright(props) {
  return (
    <Typography color="#f1f1f1" align="center" {...props}>
      {"Copyright © "}
      <Link href="/" style={{ color: "#fff", textDecoration: "none" }}>
        HANKENO INC
      </Link>{" "}
      {new Date().getFullYear()} ALL RIGHTS RESERVED.{"  "}
      <Link
        href="/privacy_policy"
        style={{ color: "#fff", textDecoration: "none" }}
      >
        PRIVACY POLICY
      </Link>
      {" | "}
      <Link
        href="/terms_of_use"
        style={{ color: "#fff", textDecoration: "none" }}
      >
        TERMS OF USE
      </Link>
    </Typography>
  );
}

export default function UnAuthLayout({ children }) {
  const path = window.location.pathname?.split("/")[1];

  const nowContactPath = ["", "privacy_policy", "terms_of_use"].includes(path);

  // console.log({ nowContactPath });

  const user = useReactiveVar(userVar);

  // console.log({ user });

  console.log({ typeofusersub: typeof user?.sub });

  if (user?.sub && typeof user.sub === "string")
    return <Navigate to="/cloud" replace />;

  return (
    <>
      <UnAuthNavbar />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          // border: 2,
          // borderColor: "secondary.main",
          // height: "100vh",
        }}
      >
        <Outlet />
        {!nowContactPath && (
          <Container>
            <ContactUsForConsultation />
          </Container>
        )}
      </Box>

      {/* <Footer /> */}
      <Copyright sx={{ p: 2, bgcolor: "#444444", fontSize: 12 }} />
    </>
  );
}

function UnAuthNavbar() {
  const userEntityRelation = useReactiveVar(userEntityRelationVar);

  const { entityType, userRole } = userEntityRelation;

  const navigate = useNavigate();

  const nav = getTopNav({
    entityType,
    userRole,
    isAuthenticated: false,
  });

  const [value, setValue] = useState(false);

  useEffect(() => {
    const menuMatched = nav.find(
      (x) => x.path === window.location.pathname.split("/")[1]
    );

    if (menuMatched) {
      setValue(menuMatched.label);
    } else {
      setValue(false);
    }
  }, [navigate, nav]);

  return (
    <AppBar position="fixed" sx={{ opacity: 0.8 }}>
      <Toolbar>
        <Stack direction="row" spacing={2} alignItems="center">
          <img src={icon} alt="icon" width={20} height={24} />

          <Typography
            variant="h6"
            noWrap
            component="a"
            style={{ cursor: "pointer" }}
            // href="/"
            onClick={() => {
              setValue(false);
              navigate("/");
            }}
            sx={{
              mr: 2,
              // fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            HANKENO
          </Typography>
        </Stack>
        <Box sx={{ flexGrow: 1, ml: 5 }}>
          <Tabs
            // TabIndicatorProps={{
            //   style: {
            //     display: value === "Home" ? "none" : "block",
            //   },
            // }}
            value={value}
            onChange={(e, val) => {
              setValue(val);
            }}
            textColor="#fff"
            indicatorColor="secondary"
            aria-label="secondary tabs example"
          >
            {nav.map((menu) => (
              <Tab
                key={menu.label}
                value={menu.label}
                label={menu.label}
                onClick={() => navigate(`/${menu.path}`)}
                sx={{
                  visibility: menu.label === "Home" ? "hidden" : "visible",
                }}
              />
            ))}
          </Tabs>
        </Box>
        <Box sx={{ flexGrow: 0, mr: 10 }}>
          <Button
            sx={{ color: "white" }}
            // href="/auth"
            onClick={() => {
              // navigate("auth");

              const vid = document.getElementById("video");

              vid && vid.pause();

              Hub.dispatch("dialogMonitor", {
                event: "auth",
                data: {},
                message: "",
              });
            }}
          >
            PORTAL
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
